module.exports = __webpack_public_path__ + "img/house.048e69d4.png";